import React, {Component} from 'react';

import Form from '../common/Form';
import Header from './Header';

class RecoverySent extends Form {

    constructor(props) {
        super(props);
        this.state = {
            user: {},
            teams: {},
            remember_me: true,
            done: false,
            spinnerActive: false,
        };
    }

    doSubmit = () => {
        this.props.history.push('/login');

    }

    render() {

        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content reset-pass-container">
                    <div className="onboarding-panel">
                        <h2 className='text-center'>We sent you the recovery email!</h2>
                        <p className='text-center'>Check your inbox and follow instructions to recover your
                            password.</p>
                        <button onClick={this.doSubmit} className='btn-action btn-m'>Return to Emitto</button>

                    </div>
                </div>
            </div>
        )
    }

}

export default RecoverySent